

import { NavLink, Link } from 'react-router-dom'
import useFetchMenu from 'Common/FetchAllMenu'
import { SidebarSkeleton } from './SidebarSkeleton '

const TuningSidebar = ({ iconColor }) => {

    const { menu: tuningMenu, loading: tuningLoading } = useFetchMenu("tunning");

    if (tuningLoading) {
        return <SidebarSkeleton iconColor={iconColor} />
    }
    const DefaultIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" className="svg-stroke" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 8m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
            <path d="M8 11a5 5 0 1 0 3.998 1.997" />
            <path d="M12.002 19.003a5 5 0 1 0 3.998 -8.003" />
        </svg>

    );
    return (

        <>
            <h6 className="fl-title title-font ps-2 small text-uppercase text-muted" style={{ "--dynamic-color": "var(--theme-color1)" }}>Configuration</h6>
            <ul className={`list-unstyled mb-4 menu-list ${iconColor}`}>
                {/* <li>
                    <NavLink to="/admin/tuning" aria-label="tuning">
                        <svg xmlns="http://www.w3.org/2000/svg" className="svg-stroke" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M19.875 6.27a2.225 2.225 0 0 1 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z" />
                            <path d="M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
                        </svg>
                        <span className="mx-3">Tuning</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/admin/common-settings" aria-label="payment set">
                        <svg xmlns="http://www.w3.org/2000/svg" className="svg-stroke" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M3 21l18 0" />
                            <path d="M5 21v-14l8 -4v18" />
                            <path d="M19 21v-10l-6 -4" />
                            <path d="M9 9l0 .01" />
                            <path d="M9 12l0 .01" />
                            <path d="M9 15l0 .01" />
                            <path d="M9 18l0 .01" />
                        </svg>
                        <span className="mx-3">Common</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/admin/payment-set" aria-label="payment set">
                        <svg xmlns="http://www.w3.org/2000/svg" className="svg-stroke" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M12 19h-6a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v4.5" />
                            <path d="M3 10h18" />
                            <path d="M16 19h6" />
                            <path d="M19 16l3 3l-3 3" />
                            <path d="M7.005 15h.005" />
                            <path d="M11 15h2" />
                        </svg>
                        <span className="mx-3">Payment Set</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/admin/accounts-setting" aria-label="Accounts Setting">
                        <svg className="svg-stroke" xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M14 3v4a1 1 0 0 0 1 1h4"></path>
                            <path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z"></path>
                            <path d="M9 7l1 0"></path>
                            <path d="M9 13l6 0"></path>
                            <path d="M13 17l2 0"></path>
                        </svg>
                        <span className="mx-3">Accounts</span>
                    </NavLink>
                </li> */}

                {/* {tuningMenu.map((parent) => (
                    <li key={parent.menu_id} className="py-2 mt-2">
                        <h6
                            className="fl-title title-font ps-2 small text-capitalize text-muted"
                            style={{ "--dynamic-color": "var(--theme-color1)" }}
                        >
                            {parent.menu_title}
                        </h6>

                        {parent.children && parent.children.length > 0 && (
                            <ul className="list-unstyled">
                                {parent.children.map((child, cIndex) => (
                                    <li key={child.menu_id}>
                                        <NavLink to={`/admin/${child.page_url}`} className={'text-capitalize'} aria-label={child.menu_title}>
                                            {child.menu_title}
                                        </NavLink>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </li>
                ))} */}

                {tuningMenu?.map((parent) => {
                    const collapseId = `menu-${parent.menu_id}`;

                    return (
                        <li key={parent.menu_id}>
                            {/* Parent menu (collapse toggle) */}
                            <Link
                                to={`#${collapseId}`}
                                data-bs-toggle="collapse"
                                aria-expanded="false"
                                className="dropdown-toggle d-flex align-items-center"
                                aria-label={parent.menu_title}
                            >
                                {/* Optional icon */}
                                {parent.icon ? (
                                    <span
                                        className="svg-stroke"
                                        dangerouslySetInnerHTML={{ __html: parent.icon }}
                                    />
                                ) : (
                                    <DefaultIcon />
                                )}

                                <span className="mx-3 text-capitalize text-wrap ">
                                    {parent.menu_title}
                                </span>
                            </Link>

                            {/* Child menu */}
                            {parent.children && parent.children.length > 0 && (
                                <ul
                                    className="collapse list-unstyled"
                                    id={collapseId}
                                >
                                    {parent.children.map((child) => (
                                        <li key={child.menu_id}>
                                            <NavLink
                                                to={`/admin/${child.page_url}`}
                                                className="text-capitalize"
                                                aria-label={child.menu_title}
                                            >
                                                {child.menu_title}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    );
                })}
                {/* <li className="py-2 mt-2">
                    <h6 className="fl-title title-font ps-2 small text-uppercase text-muted" style={{ "--dynamic-color": "var(--theme-color1)" }}>Front Pages</h6>
                    <ul className="list-unstyled">
                        <li><NavLink to="/admin/about-us" aria-label="About Us">About Us</NavLink></li>
                        <li><NavLink to="/admin/contact-us" aria-label="Contact Us">Contact Us</NavLink></li>
                        <li><NavLink to="/admin/privacy-policy" aria-label="Privacy Policy">Privacy Policy</NavLink></li>
                        <li><NavLink to="/admin/terms-conditions" aria-label="Terms Conditions">Terms Conditions</NavLink></li>
                    </ul>
                </li>
                <li className="py-2 mt-2">
                    <h6 className="fl-title title-font ps-2 small text-uppercase text-muted" style={{ "--dynamic-color": "var(--theme-color1)" }}>Application</h6>
                    <ul className="list-unstyled">
                        <li><NavLink to="/admin/calendar" aria-label="Calendar">My Calendar</NavLink></li>
                        <li><NavLink to="/admin/inbox" aria-label="Inbox">Inbox (98)</NavLink></li>
                        <li><NavLink to="/admin/chat" aria-label="Chat">Chat (2)</NavLink></li>
                        <li><NavLink to="/admin/blog" aria-label="Blog">Blog Article</NavLink></li>
                        <li><NavLink to="/admin/filemanager" aria-label="File Manager">File Manager</NavLink></li>
                    </ul>
                </li> */}
            </ul>
            {/* <h6 className="fl-title title-font ps-2 small text-uppercase text-muted" style={{ "--dynamic-color": "var(--theme-color4)" }}>Pages</h6>
            <ul className={`list-unstyled mb-4 menu-list ${iconColor}`}>
                <li>
                    <Link to="#Authentication" data-bs-toggle="collapse" aria-expanded="false" className="dropdown-toggle" aria-label="Authentication">
                        <svg className="svg-stroke" xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M11.5 21h-4.5a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2"></path>
                            <path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"></path>
                            <path d="M8 11v-4a4 4 0 1 1 8 0v4"></path>
                            <path d="M20 21l2 -2l-2 -2"></path>
                            <path d="M17 17l-2 2l2 2"></path>
                        </svg>
                        <span className="mx-3">Authentication</span>
                    </Link>
                    <ul className="collapse list-unstyled" id="Authentication">
                        <li><NavLink to="/admin/signin">Sign in</NavLink></li>
                        <li><NavLink to="/admin/signup">Sign up</NavLink></li>
                        <li><NavLink to="/admin/password-reset">Password reset</NavLink></li>
                        <li><NavLink to="/admin/two-step">2-Step Authentication</NavLink></li>
                        <li><NavLink to="/admin/lockscreen">Lockscreen</NavLink></li>
                        <li><NavLink to="/admin/maintenance">Maintenance</NavLink></li>
                        <li><NavLink to="/admin/404">404</NavLink></li>
                    </ul>
                </li>
                <li>
                    <NavLink to="/admin/search" aria-label="Search page">
                        <svg className="svg-stroke" xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
                            <path d="M21 21l-6 -6"></path>
                        </svg>
                        <span className="mx-3">Search page</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/admin/docs" aria-label="Template documentation">
                        <svg className="svg-stroke" xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M4 7h3a1 1 0 0 0 1 -1v-1a2 2 0 0 1 4 0v1a1 1 0 0 0 1 1h3a1 1 0 0 1 1 1v3a1 1 0 0 0 1 1h1a2 2 0 0 1 0 4h-1a1 1 0 0 0 -1 1v3a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-1a2 2 0 0 0 -4 0v1a1 1 0 0 1 -1 1h-3a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h1a2 2 0 0 0 0 -4h-1a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1"></path>
                        </svg>
                        <span className="mx-3">Documentation</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/admin/changelog" title="Template Changelog" aria-label="Template Changelog">
                        <svg className="svg-stroke" xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M10.09 4.01l.496 -.495a2 2 0 0 1 2.828 0l7.071 7.07a2 2 0 0 1 0 2.83l-7.07 7.07a2 2 0 0 1 -2.83 0l-7.07 -7.07a2 2 0 0 1 0 -2.83l3.535 -3.535h-3.988"></path>
                            <path d="M7.05 11.038v-3.988"></path>
                        </svg>
                        <span className="mx-3">Changelog: <b>v1.0</b></span>
                    </NavLink>
                </li>
            </ul> */}
        </>
    )
}

export default TuningSidebar